<div class="w-full bg-white p-3 md:p-5 border-round shadow-1">

  <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-4 gap-3">
    <div>
      <h2 class="text-2xl font-bold m-0 text-900">Auditoría del Sistema</h2>
      <p class="text-500 m-0 text-sm">Acciones administrativas (paginado en servidor).</p>
    </div>
    <div class="flex gap-2">
      <button pButton label="Limpiar Filtros" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear()"></button>
      <button pButton icon="pi pi-refresh" label="Recargar" class="p-button-black" (click)="onSearch()"></button>
    </div>
  </div>

  <div class="flex flex-column md:flex-row gap-2 mb-4">
    <span class="p-input-icon-left w-full md:w-auto flex-1">
      <input pInputText type="text"
             [(ngModel)]="search"
             (keyup.enter)="onSearch()"
             placeholder="Buscar en usuario, acción o detalle..."
             class="w-full" />
    </span>
    <p-select [options]="uniqueUsers"
              [(ngModel)]="selectedUsername"
              placeholder="Usuario"
              [showClear]="true"
              (onChange)="onSearch()"
              styleClass="w-full md:w-12rem"
              appendTo="body">
    </p-select>
    <p-select [options]="uniqueActions"
              [(ngModel)]="selectedAction"
              placeholder="Acción"
              [showClear]="true"
              (onChange)="onSearch()"
              styleClass="w-full md:w-14rem"
              appendTo="body">
      <ng-template let-option pTemplate="item">
        <p-tag [value]="option.label" [severity]="getActionSeverity(option.label)"></p-tag>
      </ng-template>
    </p-select>
    <button pButton icon="pi pi-search" class="p-button-black" (click)="onSearch()"></button>
  </div>

  <p-table [value]="logs"
           [lazy]="true"
           (onLazyLoad)="loadLogs($event)"
           [rows]="rows"
           [paginator]="true"
           [totalRecords]="totalRecords"
           [loading]="loading"
           [rowHover]="true"
           styleClass="p-datatable-sm"
           responsiveLayout="scroll"
           [rowsPerPageOptions]="[15, 25, 50]">

    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th style="width: 20%">Fecha</th>
        <th style="width: 15%">Usuario</th>
        <th style="width: 15%">Acción</th>
        <th style="width: 50%">Detalle</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-log>
      <tr class="text-sm">
        <td class="font-bold text-700">
          {{ log.timestamp | peruDate:'dd/MM/yyyy HH:mm:ss' }}
        </td>
        <td>
          <div class="flex align-items-center gap-2">
            <div class="w-2rem h-2rem bg-blue-50 border-circle flex align-items-center justify-content-center text-blue-500 font-bold text-xs">
              {{ log.username ? log.username.charAt(0).toUpperCase() : '?' }}
            </div>
            <span class="font-semibold text-900">{{ log.username }}</span>
          </div>
        </td>
        <td>
          <p-tag [value]="log.action" [severity]="getActionSeverity(log.action)" [rounded]="true"></p-tag>
        </td>
        <td class="text-600 line-height-3" style="word-break: break-word;">
          {{ log.details }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center p-6 text-500">
          <i class="pi pi-inbox text-4xl mb-3 block"></i>
          No se encontraron registros con los filtros aplicados.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
